import { Injectable } from '@angular/core';
import { ItemsTab } from '@b2b/features/cart/utilities/checkout-tabs.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  nameTabDeliveryMode = toSignal(this.translateService.get('checkout.deliveryMode.title'));
  nameTabDeliveryAddress = toSignal(this.translateService.get('checkout.deliveryAddress.title'));
  nameTabPaymentMethod = toSignal(this.translateService.get('checkout.paymentMethod.title'));
  nameTabPayment = toSignal(this.translateService.get('checkout.payment.title'));
  nameTabReview = toSignal(this.translateService.get('checkout.review.title'));

  itemsTabs(activeTab: string): ItemsTab[] {
    return [
      {
        name: this.nameTabDeliveryMode() ?? 'Modo de entrega',
        active: activeTab === 'modo-entrega',
        iconName: 'local_shipping',
      },
      {
        name: this.nameTabDeliveryAddress() ?? 'Endereço de entrega',
        active: activeTab === 'endereco-entrega',
        iconName: 'location_on',
      },
      {
        name: this.nameTabPaymentMethod() ?? 'Método de pagamento',
        active: activeTab === 'metodo-pagamento',
        iconName: 'credit_card',
      },
      {
        name: this.nameTabPayment() ?? 'Pagamento',
        active: activeTab === 'pagamento',
        iconName: 'payments',
      },
      {
        name: this.nameTabReview() ?? 'Revisar Pedido',
        active: activeTab === 'review',
        iconName: 'fact_check',
      },
    ];
  }

  constructor(private translateService: TranslateService) {}
}
